import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import store from '@/store'
import { AloDbFleet, isAloDbFleetCoverage, isAloDbFleetFormation } from '@/models/alodb/AloDbFleet'
import MissionDetailFtpRsync from '@/components/mission/MissionDetailFtpRsync.vue'
import FleetDetailRsync from '@/components/fleet/FleetDetailRsync.vue'
import FleetDetailFtp from '@/components/fleet/FleetDetailFtp.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FleetDetailFtpRsync',
  props: {
    fleet: null,
    isleft: { type: Boolean },
    uiid: null,
    isVisible: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  fleet: AloDbFleet
  isleft: boolean
  uiid: string
  isVisible: boolean
};



const fleetIco = computed(() => {
  return isAloDbFleetCoverage(props.fleet)
    ? 'mdi-select-group'
    : isAloDbFleetFormation(props.fleet)
    ? 'mdi-vector-circle'
    : 'mdi-multicast'
})

const missions = computed(
  () => props.fleet.activeMissionIds?.map((id) => store.myGetters?.missionsById[id])?.filter((m) => !!m) ?? []
)

const gliders = computed(() => missions.value.map((m) => ({ id: m.misId, libelle: m.gliKey })))

const selectedGliderIdx = ref(0)

return { __sfc: true,props, fleetIco, missions, gliders, selectedGliderIdx, store, MissionDetailFtpRsync, FleetDetailRsync, FleetDetailFtp }
}

})